import type { IconsProps } from '@makemydeal/dr-sales-checkin-types';
import React from 'react';
import { StyledVehicleDetailIcon } from './vehicleDetailIcon.style';

export const VehicleDetailIcon: React.FC<IconsProps> = ({ onClick, fill = '#6D6D6D' }) => (
    <StyledVehicleDetailIcon
        onClick={onClick}
        data-testid="vehicle-detail-icon"
        width="17"
        height="21"
        viewBox="0 0 17 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M1.875 1.5C1.66789 1.5 1.5 1.66789 1.5 1.875V19.125C1.5 19.3321 1.66789 19.5 1.875 19.5H14.625C14.8321 19.5 15 19.3321 15 19.125V10.125C15 8.67525 13.8247 7.5 12.375 7.5H10.875C9.83947 7.5 9 6.66053 9 5.625V4.125C9 2.67525 7.82475 1.5 6.375 1.5H1.875ZM1.875 0C0.839466 0 0 0.839465 0 1.875V19.125C0 20.1605 0.839466 21 1.875 21H14.625C15.6605 21 16.5 20.1605 16.5 19.125V9.75C16.5 4.36522 12.1348 0 6.75 0H1.875ZM10.007 2.16785C10.3215 2.75019 10.5 3.41675 10.5 4.125V5.625C10.5 5.83211 10.6679 6 10.875 6H12.375C13.0832 6 13.7498 6.1785 14.3322 6.49296C13.4988 4.55549 11.9445 3.00123 10.007 2.16785Z"
            fill={fill}
        />
    </StyledVehicleDetailIcon>
);
